import { t } from '../../shared/config/translations'

export function infiniteListSentinelTemplate(): string {
	return `<div class="sentinel"></div>`
}

export function infiniteListEndTemplate(): string {
	return `<p class="infinite-list-end f secondary small" hidden>${t('common.listEnd')}</p>`
}

export function scrollTopButtonTemplate(): string {
	return `
        <button id="scroll-top-btn" type="button" class="scroll-top-btn btn icon secondary">
            <svg><use href="#symbols-arrow-back"></use></svg>
        </button>
    `
}
